var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGimbal = function SvgGimbal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 62,
    viewBox: "0 0 66 62",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9FADC5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.985 3.073a10.486 10.486 0 00-2.209 11.583L5.936 16.5a.372.372 0 01-.524 0l-.864-.864a.369.369 0 00-.522 0l-3.629 3.66a.366.366 0 000 .524l8.324 8.323c.145.145.379.145.524 0l3.64-3.649a.372.372 0 000-.524l-.864-.864a.372.372 0 010-.524l2.134-2.134c1.638.53 3.38.65 5.075.348l6.336 6.336a.576.576 0 00.812 0L30.41 23.1a.576.576 0 000-.815L25.38 17.28A10.486 10.486 0 009.985 3.073zm13.582 5.328a2.016 2.016 0 010 2.837l-5.423 5.417a2.016 2.016 0 01-2.837 0l-4.075-4.08a2.016 2.016 0 010-2.835l5.42-5.42a2.016 2.016 0 012.837 0l4.078 4.081z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.4,
    cy: 10.488,
    r: 2.051,
    transform: "rotate(-76.72 17.4 10.488)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.081 32.832a.922.922 0 01-.144-.156l-6.379-9.596a.98.98 0 00-1.474-.11l-.576.577-1.193-1.192a1.253 1.253 0 00-1.777 0l-7.07 7.067a1.261 1.261 0 000 1.78l1.192 1.192-.576.576a.973.973 0 00.11 1.475l9.584 6.382c.056.042.107.089.153.141L53.297 61.69a.973.973 0 001.423.046l10.126-10.124a.976.976 0 00-.049-1.425L44.081 32.832zm-9.458 2.69a2.946 2.946 0 110-4.674 2.952 2.952 0 010 4.662v.012zm5.668-.542a1.616 1.616 0 11-2.638 0 1.61 1.61 0 012.638-.011v.011zm-.697-6.085a1.616 1.616 0 11-2.64 0 1.619 1.619 0 012.64-.011v.011z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGimbal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gimbal.ac0b9841.svg";
export { ForwardRef as ReactComponent };